<template>
  <el-dialog
    v-if="model"
    title="请求处理"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      v-if="model"
      ref="form"
      label-width="90px"
      :model="model"
      label-position="top"
      :rules="formRules"
    >
      <el-form-item label="请输入处理方式" prop="manage_result">
        <el-autocomplete
        style="width:100%"
          class="inline-input"
          v-model="model.manage_result"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
        ></el-autocomplete>
        </el-input>
      </el-form-item>
      <div>
        <span></span>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  createDeviceQuest,
  createUsedDevice,
  deviceQuestManage,
  updatedeviceQuest,
  updateUsedDevice,
} from '../../service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    quest: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  computed: {
    options() {
      if (this.quest && this.quest.category == 1) {
        return this.buyingOptions
      } else {
        return this.recycleOptions
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        manage_result: [
          { required: true, message: '请输入处理方式', trigger: 'blur' },
        ],
      },
      buyingOptions: ['到货后第一时间通知', '暂无此类型设备'],
      recycleOptions: [
        '已知晓，近期将电话联系',
        '暂不收购此设备，感谢提供信息',
      ],
      submiting: false,
    }
  },
  created() {},
  methods: {
    querySearch(queryString, cb) {
      cb(
        this.options.map((v) => {
          return { value: v }
        })
      )
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          let res = await deviceQuestManage(this.model)
          if (res.code == 0) {
            this.$emit('done', res.data)
          }

          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
        }
      })
    },
  },
}
</script>